import { createFileRoute } from '@tanstack/react-router'

import { AdminClubsPage } from '@/features/admin/AdminClubsPage'

export const Route = createFileRoute('/_admin/admin/clubs')({
  component: AdminClubsPage,
})
